
  import Vue from 'vue';
  import {mapState, mapMutations} from 'vuex';
  import {Track} from '@/models/track';
  import * as VuexMutation from '@/store/mutation-types';
  import * as util from '@/util';

  export default Vue.extend({
    name: 'Queue',
    components: {
      TrackList: () => import('@/components/TrackList.vue'),
    },
    computed: {
      ...mapState(['playingTrack', 'queuedTracks', 'playerRepeat']),
      playingTrackIndex(): number {
        if (!this.playingTrack) return 0;
        return this.queuedTracks.map((track: Track) => track.uuid).indexOf(this.playingTrack.uuid) + 1;
      },
      repeatIcon(): string {
        if (this.playerRepeat === 'repeat-off') return 'mdi-repeat-off';
        else if (this.playerRepeat === 'repeat') return 'mdi-repeat';
        else if (this.playerRepeat === 'repeat-once') return 'mdi-repeat-once';
        else throw new Error('invalid repeat option');
      }
    },
    methods: {
      ...mapMutations({
        setQueue: VuexMutation.SET_QUEUE,
        setPlayingTrack: VuexMutation.SET_PLAYING_TRACK,
        setPlayerRepeat: VuexMutation.SET_PLAYER_REPEAT,
      }),
      cloneTrack(track: Track): Track {
        return track.clone();
      },
      onChange(tracks: Track[]) {
        this.setQueue(tracks.map((track: Track) => track));
      },
      onDeleted(targetTrack: Track) {
        this.setQueue(this.queuedTracks.filter(
          (track: Track) => track.uuid !== targetTrack.uuid
        ))
      },
      clean() {
        this.setQueue([]);
      },
      scrollPlayingTrackIntoView() {
        const queueElement = document.getElementById("queue") as Element;
        const nowPlayingTrackElement = queueElement.getElementsByClassName("nowPlayingTrack")[0];
        if (nowPlayingTrackElement) {
          nowPlayingTrackElement.scrollIntoView({ behavior: 'smooth' });
        }
      },
      shuffle() {
        let tracks = util.shuffle(this.queuedTracks as Track[]);
        if (
          this.playingTrack
          && tracks.map(track => track.uuid).indexOf(this.playingTrack.uuid) >= 0
        ) {
          tracks = tracks.filter(track => track.uuid !== this.playingTrack.uuid);
          tracks.unshift(this.playingTrack);
        }
        this.setQueue(tracks);

        // scroll the top track on the queue into view
        const queueElement = document.getElementById("queue") as Element;
        const nowPlayingTrackElement = queueElement.getElementsByClassName("track")[0];
        if (nowPlayingTrackElement) {
          nowPlayingTrackElement.scrollIntoView({ behavior: 'smooth' });
        }
      },
      togglePlayerRepeat() {
        if (this.playerRepeat === 'repeat-off') {
          this.setPlayerRepeat('repeat');
        } else if (this.playerRepeat === 'repeat') {
          this.setPlayerRepeat('repeat-once');
        } else if (this.playerRepeat === 'repeat-once'){
          this.setPlayerRepeat('repeat-off');
        } else {
          throw new Error('invalid repeat option');
        }
      },
    },
  })
